import { useCallback } from 'react';
import { PermissionsAndroid, Platform } from 'react-native';

import WifiManager from 'react-native-wifi-reborn';

export const useWiFiManager = () => {
  // Taken from https://www.npmjs.com/package/react-native-wifi-reborn
  const requestWiFiPermissions = useCallback(async () => {
    if (Platform.OS === 'ios') {
      return true;
    }

    if (
      Platform.OS === 'android' &&
      PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION
    ) {
      const granted = await PermissionsAndroid.request(
        PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION
      );
      return granted === PermissionsAndroid.RESULTS.GRANTED;
    }

    return false;
  }, []);

  const getCurrentWifiSSID = async () => {
    const hasPermission = await requestWiFiPermissions();
    if (!hasPermission) {
      return;
    }

    try {
      const ssid = await WifiManager.getCurrentWifiSSID();
      return ssid;
    } catch (e) {
      console.error('Failed to get current wifi ssid', e);
      return;
    }
  };

  return {
    requestWiFiPermissions,
    getCurrentWifiSSID,
  };
};
